import { VehicleList } from "./VehicleList";

export function TractorsList() {
  return <VehicleList resource="tractors" />;
}
